import { Action } from 'redux';

import { ClearUserNotificationsState } from '../../../app/actions/AppActionTypes';
import { isActionFactory } from '../../../app/actions/isActionFactory';

export interface ClearUserNotificationsStateAction extends Action { }

export function clearUserNotificationsStateAction(): ClearUserNotificationsStateAction {
  return {
    type: ClearUserNotificationsState,
  };
}

export const isClearUserNotificationsStateAction = isActionFactory<ClearUserNotificationsStateAction>(ClearUserNotificationsState);
